import { Flex, Layout, Spin } from "antd"
import React, { useState } from "react"
import { type ConnectedProps, connect } from "react-redux"
import { Outlet } from "react-router-dom"

import { type RootState } from "../../store"
import { Header } from "../Header"
import { SidebarController } from "../Sidebar/SidebarController.tsx"

const { Content } = Layout

function CustomLayout({
  auth,
  userInfo,
  isAdmin,
  isLogoutPending = false
}: ConnectedProps<typeof connector>) {
  const isAuthUserPages = !!auth?.accessToken && !!userInfo && !isAdmin

  return (
    <Spin size="large" spinning={isLogoutPending}>
      <Layout id="global-wrap" className="min-h-svh flex flex-col">
        <Header />
        <Flex flex={1}>
          <SidebarController />
          {/* min-w-0: flex items default to min-width:auto, which lets a wide table stretch the shell. */}
          <Content
            id="main-content"
            className="p-2 lg:px-4 lg:py-3 min-w-0 max-w-screen"
          >
            <Outlet context={{ isAuthUserPages }} />
          </Content>
        </Flex>
      </Layout>
    </Spin>
  )
}

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  userInfo: state.auth.userInfo,
  isLogoutPending: state.auth.isLogoutPending,
  isAdmin: state.auth.isAdmin,
  isMobile: state.nav.isMobile
})

const connector = connect(mapStateToProps, null)
export default connector(CustomLayout)
